// @flow
import React, { useEffect } from 'react';
import {
    Box,
    Button,
    Typography,
    useMediaQuery,
    Grid,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { CALCULATIONS } from "../../locales/namespaces";
import { getRouteUrl } from "../../../../helpers/getRouteUrl";
import Breadcrumb from "../../../../components/breadcrumb/breadcrumb";
import { ROUTE_PAGE_HOME } from "../../../../routers/routes";
import { Link } from "react-router-dom";
import {
    ROUTE_PAGE_CALCULATIONS_CREATE
} from "../../routes/routes";
import IndexListCalculations from "../../components/indexList/indexList";
import { withPermissionHOC } from "../../../permission/components/permissionHOC/permissionHOC";
import PlusIcon from "../../../../../src/assets/images/icons/buttonsIcons/plusIcon";

const Index = () => {
    const { t } = useTranslation(CALCULATIONS)
    const matchDownSM = useMediaQuery((theme) => theme.breakpoints.down('sm'));

    useEffect(() => {
        document.title = t('IMS Financial Consulting | Calculations')
    }, [t])

    return (
        <Box>


            <Grid container alignItems="center" justifyContent="space-between" sx={{ margin:{xs:'18px 0 10px 0', sm:'40px 0 10px 0', md:'40px 0 10px 0'}}}>
                <Grid item xs={7} sm={7} md={6} lg={6}>
                    <Typography className='title-xsm color-default' sx={{marginLeft:'12px', fontSize:{xs:'18px !important',sm:'22px !important'}}}>
                        {t('My calculations')}
                    </Typography>
                </Grid>
                <Grid item>
                    <Button
                        size={"small"}
                        variant={"contained"}
                        color={'info'}
                        sx={{ textAlign: 'center', padding: { xs: '8px' }, minWidth: { xs: 'inherit' } }}
                        component={Link}
                        to={getRouteUrl(ROUTE_PAGE_CALCULATIONS_CREATE)}
                    >
                        <PlusIcon /> <Box component="span" sx={{ marginLeft: '10px', display: { xs: 'none', sm:'inline' } }}>{t('Add loan scenario')}</Box>
                    </Button>
                </Grid>
            </Grid>
            <IndexListCalculations />
        </Box>
    );
};

export default withPermissionHOC(Index, ['access_calculations_index'])